import { LuSearch } from "@/Components/Icons/Icons";

export default {
  row1 :[
  {
    column: "column1",
    rows: {
      row1: [
        {
          name: "deecItemsrnopartE",
          label: "Item SNo (Part E)(Export item)",
          component: "text-field",
            width : "33%"

        },
        {
          name: "deeExportQtyUnderLic",
          label: "Export Qty Under Licence",
          component: "text-field",
          dataType : "int",
            width : "33%"

        },        
      ],
      row2: [
        {
          name: "licRefNo",
          label: "Rate List Sr No",
          component: "text-field",
          icon: LuSearch,
          type: "autocomplete",
        },
      ],
      row3: [
        {
          name: "deecRegNo",
          label: "Regn No",
          component: "text-field",
        },
      ],
      row4:[
        {
          name: "deecRegDate",
          label: "Date",
          component: "dateSelector",
          width : "100%"
        },
      ],
      
    },
  },
]
};
